/* eslint-disable react-hooks/rules-of-hooks */
// React&NextJS
import React, { useEffect, useState } from 'react'
import { DragControls } from 'framer-motion'

type Props = {
    variant?:
        | 'search'
        | 'calendar'
        | 'arrow'
        | 'arrowL'
        | 'heart'
        | 'upload'
        | 'galleryUpload'
        | 'mobile'
        | 'location'
        | 'link'
        | 'email'
        | 'logo'
        | 'share'
        | 'info'
        | 'checkmark'
        | 'account'
        | 'dot'
        | 'image'
        | 'trash'
        | 'settings'
        | 'dropdown'
        | 'edit'
        | 'save'
        | 'close'
        | 'crumbArrow'
        | 'facebook'
        | 'instagram'
        | 'reorder'
        | 'cloud'
        | 'dragDots'
        | 'x'
        | 'star'
        | 'youtube'
        | 'spotify'
        | 'google'
        | 'rectangle'
        | 'youtube2'
        | 'bookmark'
    children?: React.ReactNode
    width?: string
    height?: string
    [key: string]: unknown
    dragControls?: DragControls
    fill?: boolean
}

//TODO: refactor into dynamically imported SVGs
export const Icon = ({
    variant,
    width,
    height,
    dragControls,
    fill,
    ...props
}: Props) => {
    if (variant === 'arrow') {
        return (
            <svg
                width="20"
                height="14"
                viewBox="0 0 20 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M12.5838 13.6857L19.1159 7.15358C19.1168 7.15249 19.1169 7.1514 19.118 7.1503C19.1504 7.11719 19.1764 7.07825 19.1945 7.03476C19.2127 6.9911 19.2217 6.94488 19.2221 6.8983L19.2225 6.89594C19.2225 6.84845 19.2127 6.80132 19.1945 6.75674C19.1757 6.71235 19.1493 6.67213 19.1159 6.63866L12.5838 0.106578C12.4417 -0.0355261 12.2113 -0.0355261 12.0692 0.106578C11.9979 0.177722 11.9626 0.270881 11.9626 0.363858C11.9626 0.457018 11.9979 0.550177 12.0692 0.621139L17.9801 6.53221H0.363904C0.163029 6.53221 0 6.69524 0 6.89612C0 7.09699 0.163029 7.25984 0.363904 7.25984H17.9803L12.0692 13.1711C11.9979 13.2419 11.9626 13.3349 11.9626 13.4284C11.9626 13.5215 11.9979 13.6142 12.0692 13.6857C12.2113 13.8276 12.4413 13.8276 12.5838 13.6857Z"
                    fill="#2B4C6A"
                />
            </svg>
        )
    } else if (variant === 'search') {
        return (
            <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M20.8144 19.769L16.5466 15.5328C19.7294 11.8397 19.5486 6.26379 16.0403 2.75172C14.2319 0.905173 11.8087 0 9.42164 0C7.03458 0 4.61136 0.905173 2.76682 2.75172C-0.922272 6.44483 -0.922272 12.3828 2.76682 16.0759C4.57519 17.8862 6.99842 18.8276 9.42164 18.8276C11.5917 18.8276 13.7979 18.0672 15.534 16.5466L19.8017 20.819C19.9102 20.9276 20.0911 21 20.2719 21C20.4527 21 20.6336 20.9276 20.7782 20.7828C21.0676 20.5293 21.0676 20.0586 20.8144 19.769ZM3.77951 15.0259C2.26047 13.5414 1.46478 11.5138 1.46478 9.41379C1.46478 7.31379 2.29664 5.28621 3.77951 3.76552C5.29854 2.24483 7.28776 1.44828 9.42164 1.44828C11.5555 1.44828 13.5447 2.28103 15.0638 3.76552C16.5466 5.28621 17.3785 7.27759 17.3785 9.41379C17.3785 11.55 16.5466 13.5414 15.0638 15.0621C13.5447 16.5466 11.5194 17.3793 9.42164 17.3793C7.32393 17.3793 5.29854 16.5466 3.77951 15.0259Z"
                    fill="#2B4C6A"
                />
            </svg>
        )
    } else if (variant === 'calendar') {
        return (
            <svg
                width="24"
                height="22"
                viewBox="0 0 24 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M20.597 1.77419H18.6269V0.532258C18.6269 0.248387 18.3761 0 18.0896 0C17.803 0 17.5522 0.248387 17.5522 0.532258V1.77419H6.44776V0.532258C6.44776 0.248387 6.19701 0 5.91045 0C5.62388 0 5.37313 0.248387 5.37313 0.532258V1.77419H3.40299C1.5403 1.77419 0 3.3 0 5.14516V18.629C0 20.4742 1.5403 22 3.40299 22H20.597C22.4597 22 24 20.4742 24 18.629V5.14516C24 3.26452 22.4597 1.77419 20.597 1.77419ZM3.40299 2.83871H5.37313V5.5C5.37313 5.78387 5.62388 6.03226 5.91045 6.03226C6.19701 6.03226 6.44776 5.78387 6.44776 5.5V2.83871H17.5522V5.5C17.5522 5.78387 17.803 6.03226 18.0896 6.03226C18.3761 6.03226 18.6269 5.78387 18.6269 5.5V2.83871H20.597C21.8866 2.83871 22.9254 3.86774 22.9254 5.14516V8.83548H1.07463V5.14516C1.07463 3.86774 2.11343 2.83871 3.40299 2.83871ZM20.597 20.9355H3.40299C2.11343 20.9355 1.07463 19.9065 1.07463 18.629V9.9H22.9254V18.629C22.9254 19.9065 21.8866 20.9355 20.597 20.9355Z"
                    fill="#2B4C6A"
                />
            </svg>
        )
    } else if (variant === 'dot') {
        return (
            <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="7" cy="7" r="7" fill="#C4C4C4" />
            </svg>
        )
    } else if (variant === 'upload') {
        return (
            <svg
                width="24"
                height="20"
                viewBox="0 0 24 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M11.9999 10.586L16.2429 14.828L14.8279 16.243L12.9999 14.415V20H10.9999V14.413L9.17189 16.243L7.75689 14.828L11.9999 10.586ZM11.9999 2.2216e-08C13.7169 8.17698e-05 15.374 0.631114 16.6561 1.77312C17.9382 2.91512 18.756 4.48846 18.9539 6.194C20.1982 6.53332 21.2836 7.2991 22.0206 8.35753C22.7575 9.41595 23.099 10.6997 22.9855 11.9844C22.872 13.2691 22.3106 14.473 21.3995 15.3858C20.4883 16.2986 19.2854 16.8622 18.0009 16.978V14.964C18.4611 14.8983 18.9035 14.7416 19.3025 14.503C19.7014 14.2644 20.0488 13.9487 20.3245 13.5744C20.6001 13.2001 20.7984 12.7746 20.9078 12.3228C21.0172 11.8711 21.0355 11.402 20.9616 10.9431C20.8878 10.4841 20.7232 10.0445 20.4776 9.64985C20.232 9.25519 19.9102 8.91342 19.5311 8.64447C19.152 8.37552 18.7231 8.18479 18.2694 8.08341C17.8158 7.98203 17.3465 7.97203 16.8889 8.054C17.0455 7.32489 17.037 6.56997 16.8641 5.84455C16.6912 5.11913 16.3582 4.44158 15.8895 3.86153C15.4208 3.28147 14.8283 2.81361 14.1554 2.49219C13.4824 2.17078 12.7461 2.00397 12.0004 2.00397C11.2546 2.00397 10.5183 2.17078 9.84542 2.49219C9.1725 2.81361 8.57999 3.28147 8.1113 3.86153C7.64261 4.44158 7.3096 5.11913 7.13668 5.84455C6.96375 6.56997 6.95528 7.32489 7.11189 8.054C6.19955 7.88267 5.25651 8.08079 4.49024 8.60476C3.72396 9.12874 3.19722 9.93565 3.02589 10.848C2.85456 11.7603 3.05268 12.7034 3.57666 13.4697C4.10063 14.2359 4.90755 14.7627 5.81989 14.934L5.99989 14.964V16.978C4.71534 16.8623 3.5123 16.2989 2.60103 15.3862C1.68976 14.4735 1.12822 13.2696 1.01457 11.9848C0.900915 10.7001 1.24237 9.41628 1.97926 8.35777C2.71615 7.29926 3.8016 6.53339 5.04589 6.194C5.2436 4.48838 6.0613 2.91491 7.34347 1.77287C8.62565 0.63082 10.2829 -0.000136703 11.9999 2.2216e-08Z"
                    fill="#09121F"
                />
            </svg>
        )
    } else if (variant === 'galleryUpload') {
        return (
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6 0V4H2V18H18V2H19.008C19.556 2 20 2.445 20 2.993V19.007C19.9982 19.2696 19.8931 19.521 19.7075 19.7068C19.5219 19.8926 19.2706 19.9979 19.008 20H0.992C0.728813 19.9997 0.476497 19.895 0.290489 19.7088C0.104482 19.5226 -1.33455e-07 19.2702 0 19.007V2.993C0.00183004 2.73038 0.1069 2.47902 0.292513 2.29322C0.478126 2.10742 0.72938 2.00209 0.992 2H4V0H6ZM10 7L14 11H11V15H9V11H6L10 7ZM16 0V4H8V2H14V0H16Z"
                    fill="#858585"
                />
            </svg>
        )
    } else if (variant === 'mobile') {
        return (
            <svg
                width="10"
                height="14"
                viewBox="0 0 10 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M7.33366 0.583252H2.66699C1.69866 0.583252 0.916992 1.36492 0.916992 2.33325V11.6666C0.916992 12.6349 1.69866 13.4166 2.66699 13.4166H7.33366C8.30199 13.4166 9.08366 12.6349 9.08366 11.6666V2.33325C9.08366 1.36492 8.30199 0.583252 7.33366 0.583252ZM6.16699 12.2499H3.83366V11.6666H6.16699V12.2499ZM8.06283 10.4999H1.93783V2.33325H8.06283V10.4999Z"
                    fill="#666666"
                />
            </svg>
        )
    } else if (variant === 'location') {
        return (
            <svg
                width="12"
                height="14"
                viewBox="0 0 10 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M5.00033 0.166748C2.74283 0.166748 0.916992 1.99258 0.916992 4.25008C0.916992 7.31258 5.00033 11.8334 5.00033 11.8334C5.00033 11.8334 9.08366 7.31258 9.08366 4.25008C9.08366 1.99258 7.25783 0.166748 5.00033 0.166748ZM5.00033 5.70842C4.19533 5.70842 3.54199 5.05508 3.54199 4.25008C3.54199 3.44508 4.19533 2.79175 5.00033 2.79175C5.80533 2.79175 6.45866 3.44508 6.45866 4.25008C6.45866 5.05508 5.80533 5.70842 5.00033 5.70842Z"
                    fill="#666666"
                />
            </svg>
        )
    } else if (variant === 'link') {
        return (
            <svg
                width="14"
                height="8"
                viewBox="0 0 12 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M1.27533 2.99992C1.27533 2.00242 2.08616 1.19159 3.08366 1.19159H5.41699V0.083252H3.08366C1.47366 0.083252 0.166992 1.38992 0.166992 2.99992C0.166992 4.60992 1.47366 5.91658 3.08366 5.91658H5.41699V4.80825H3.08366C2.08616 4.80825 1.27533 3.99742 1.27533 2.99992ZM3.66699 3.58325H8.33366V2.41659H3.66699V3.58325ZM8.91699 0.083252H6.58366V1.19159H8.91699C9.91449 1.19159 10.7253 2.00242 10.7253 2.99992C10.7253 3.99742 9.91449 4.80825 8.91699 4.80825H6.58366V5.91658H8.91699C10.527 5.91658 11.8337 4.60992 11.8337 2.99992C11.8337 1.38992 10.527 0.083252 8.91699 0.083252Z"
                    fill="#666666"
                />
            </svg>
        )
    } else if (variant === 'email') {
        return (
            <svg
                width="14"
                height="12"
                viewBox="0 0 12 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M10.667 0.333252H1.33366C0.691992 0.333252 0.172826 0.858252 0.172826 1.49992L0.166992 8.49992C0.166992 9.14158 0.691992 9.66658 1.33366 9.66658H10.667C11.3087 9.66658 11.8337 9.14158 11.8337 8.49992V1.49992C11.8337 0.858252 11.3087 0.333252 10.667 0.333252ZM10.667 2.66658L6.00033 5.58325L1.33366 2.66658V1.49992L6.00033 4.41658L10.667 1.49992V2.66658Z"
                    fill="#666666"
                />
            </svg>
        )
    } else if (variant === 'logo') {
        return (
            <svg
                width="204"
                height="54"
                viewBox="0 0 204 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M75.8032 20.5386H77.4108C77.598 20.5386 77.7853 20.6478 77.8477 20.8351L82.2177 30.964H82.3269L86.3067 20.8507C86.3847 20.6634 86.5564 20.5386 86.7593 20.5386H88.3356C88.5541 20.5386 88.7414 20.7102 88.7414 20.9444V33.0866C88.7414 33.305 88.5541 33.4923 88.3356 33.4923H87.2275C87.009 33.4923 86.8217 33.305 86.8217 33.0866V24.6276H86.7125L83.3102 33.1958C83.2477 33.3675 83.0761 33.4923 82.8888 33.4923H81.5778C81.3905 33.4923 81.2188 33.3831 81.1564 33.2114L77.4264 24.5496H77.3171V33.0866C77.3171 33.305 77.1454 33.4767 76.9269 33.4767H75.7876C75.5691 33.4767 75.3975 33.305 75.3975 33.0866V20.9444C75.3975 20.7102 75.5847 20.5386 75.8032 20.5386Z"
                    fill="#383C44"
                />
                <path
                    d="M95.3902 20.5386H96.5763C96.7948 20.5386 96.9821 20.7259 96.9821 20.9444V33.0709C96.9821 33.2894 96.7948 33.4767 96.5763 33.4767H95.3902C95.1717 33.4767 94.9844 33.2894 94.9844 33.0709V20.9444C94.9844 20.7102 95.1717 20.5386 95.3902 20.5386Z"
                    fill="#383C44"
                />
                <path
                    d="M103.615 20.5386H105.113C105.254 20.5386 105.394 20.6166 105.456 20.7258L111.465 30.1056H111.574V20.9287C111.574 20.7102 111.762 20.5229 111.98 20.5229H113.119C113.338 20.5229 113.525 20.7102 113.525 20.9287V33.0865C113.525 33.305 113.354 33.4767 113.135 33.4767H111.621C111.481 33.4767 111.34 33.3987 111.278 33.2894L105.3 23.9097H105.191V33.0865C105.191 33.305 105.004 33.4923 104.785 33.4923H103.63C103.412 33.4923 103.225 33.305 103.225 33.0865V20.9443C103.225 20.7102 103.396 20.5386 103.615 20.5386Z"
                    fill="#383C44"
                />
                <path
                    d="M120.314 20.5386H121.812C121.953 20.5386 122.093 20.6166 122.156 20.7258L128.164 30.1056H128.274V20.9287C128.274 20.7102 128.461 20.5229 128.679 20.5229H129.819C130.037 20.5229 130.224 20.7102 130.224 20.9287V33.0865C130.224 33.305 130.053 33.4767 129.834 33.4767H128.32C128.18 33.4767 128.039 33.3987 127.977 33.2894L122 23.9097H121.89V33.0865C121.89 33.305 121.703 33.4923 121.485 33.4923H120.33C120.111 33.4923 119.924 33.305 119.924 33.0865V20.9443C119.924 20.7102 120.096 20.5386 120.314 20.5386Z"
                    fill="#383C44"
                />
                <path
                    d="M136.998 20.5386H138.184C138.403 20.5386 138.59 20.7259 138.59 20.9444V33.0709C138.59 33.2894 138.403 33.4767 138.184 33.4767H136.998C136.78 33.4767 136.592 33.2894 136.592 33.0709V20.9444C136.592 20.7102 136.78 20.5386 136.998 20.5386Z"
                    fill="#383C44"
                />
                <path
                    d="M145.207 20.5386H146.705C146.846 20.5386 146.971 20.6166 147.049 20.7259L153.073 30.1212H153.182V20.9444C153.182 20.7259 153.369 20.5386 153.588 20.5386H154.727C154.946 20.5386 155.133 20.7259 155.133 20.9444V33.0709C155.133 33.2894 154.946 33.4767 154.727 33.4767H153.213C153.073 33.4767 152.948 33.3987 152.87 33.2894L146.893 23.8941H146.783V33.0709C146.783 33.2894 146.596 33.4767 146.378 33.4767H145.223C145.004 33.4767 144.817 33.2894 144.817 33.0709V20.9287C144.801 20.7103 144.989 20.5386 145.207 20.5386Z"
                    fill="#383C44"
                />
                <path
                    d="M160.643 27C160.643 23.192 163.452 20.2891 167.369 20.2891C170.319 20.2891 172.519 21.9434 173.409 24.2532C173.487 24.4561 173.347 24.6746 173.128 24.6746H171.708C171.505 24.6746 171.318 24.5654 171.224 24.3937C170.553 23.0671 169.211 22.1775 167.354 22.1775C164.466 22.1775 162.562 24.4093 162.703 27.3122C162.828 29.8093 164.888 31.8538 167.385 31.8538C169.741 31.8538 171.552 30.3711 171.692 28.2642H167.463C167.244 28.2642 167.057 28.0769 167.057 27.8584V26.9844C167.057 26.7659 167.244 26.5787 167.463 26.5787H173.503C173.737 26.5787 173.94 26.7815 173.94 27.0157C173.83 31.37 170.959 33.711 167.385 33.711C163.467 33.711 160.643 30.855 160.643 27Z"
                    fill="#383C44"
                />
                <path
                    d="M182.789 20.5386H184.537C184.74 20.5386 184.911 20.6634 184.989 20.8507L189.562 33.1646C189.625 33.3207 189.5 33.4767 189.344 33.4767H187.845C187.674 33.4767 187.518 33.3675 187.471 33.2114L186.55 30.6675H180.729L179.808 33.2114C179.745 33.3675 179.605 33.4767 179.433 33.4767H177.998C177.841 33.4767 177.732 33.3207 177.779 33.1646L182.336 20.8507C182.399 20.6634 182.586 20.5386 182.789 20.5386ZM185.926 28.8727L183.71 22.7704H183.585L181.353 28.8727H185.926Z"
                    fill="#383C44"
                />
                <path
                    d="M194.728 20.9444C194.728 20.7259 194.915 20.5386 195.134 20.5386H199.348C201.985 20.5386 203.686 22.1617 203.686 24.5183C203.686 26.36 202.547 27.749 201.111 28.264L203.858 33.1334C203.952 33.2894 203.827 33.4767 203.655 33.4767H202.032C201.876 33.4767 201.736 33.3987 201.673 33.2582L199.145 28.5605H196.71V33.0709C196.71 33.2894 196.523 33.4767 196.304 33.4767H195.118C194.9 33.4767 194.712 33.2894 194.712 33.0709V20.9444H194.728ZM199.254 26.8282C200.627 26.8282 201.642 26.0478 201.642 24.5183C201.642 23.2542 200.799 22.2553 199.176 22.2553H196.71V26.8282H199.254Z"
                    fill="#383C44"
                />
                <path
                    d="M27 0C12.111 0 0 12.111 0 27C0 41.889 12.111 54 27 54C41.889 54 54 41.889 54 27C54.0156 12.111 41.9046 0 27 0ZM50.4884 35.3653C49.2399 37.8936 46.6647 39.2046 43.4341 39.2046C40.1098 39.2046 37.5659 37.0353 35.0844 34.304C37.0353 35.1624 39.2827 35.7399 41.811 35.7399C45.9156 35.7399 49.0526 34.1012 51.1283 30.8861C51.378 30.5116 51.5809 30.137 51.7682 29.7624C51.815 31.2295 51.3 33.7266 50.4884 35.3653ZM4.57283 24.2532C6.46127 21.7873 9.52023 20.4295 13.141 20.4295C15.9035 20.4295 18.026 21.3971 19.8832 22.7081C19.1965 22.5988 18.4786 22.5364 17.7295 22.5364C7.47572 22.5364 3.96416 29.8249 3.18381 34.3821C2.94971 33.6173 2.74682 32.8214 2.57514 32.0254C2.2474 29.2162 2.96532 26.3445 4.57283 24.2532ZM48.9434 15.1699C49.7861 16.7306 50.4728 18.385 50.9723 20.1173C52.0179 23.9254 51.5341 27.6243 49.5832 30.4023C47.8509 32.8682 45.1353 34.2884 42.1075 34.2884C39.0329 34.2884 35.9428 33.1647 32.9306 30.9642C33.6642 31.1046 34.3977 31.1671 35.1312 31.1671C41.4676 31.1671 44.8387 27.7335 46.5399 24.8462C48.5688 21.4127 49.2243 17.5578 48.9434 15.1699ZM27 2.07572C33.0243 2.07572 38.5647 4.22948 42.8723 7.80347C46.8988 11.1902 46.9925 16.8399 44.9948 21.7093C43.1688 26.1416 39.5012 28.904 35.4277 28.904C32.2751 28.904 29.4347 27.7491 26.4694 25.2832L25.9543 24.8619C22.5364 21.9902 17.8543 18.0416 12.2358 18.0416C6.88266 18.0416 3.93295 20.726 2.29422 23.5353C4.01098 11.4243 14.4364 2.07572 27 2.07572ZM27 51.9399C18.2913 51.9399 10.5971 47.4451 6.14913 40.6561C6.16474 40.6561 6.16474 40.6561 6.16474 40.6561C4.0422 37.5971 4.99422 33.2428 6.72659 29.8873C8.14682 27.1092 11.5179 23.7382 17.2769 23.7382C22.5988 23.7382 26.4381 28.3578 30.1526 32.8214C33.7734 37.1601 38.0341 41.6393 43.0283 41.6393C45.3381 41.6393 46.6803 41.3896 47.726 40.859C43.2468 47.5231 35.6306 51.9399 27 51.9399Z"
                    fill="#9A4534"
                />
            </svg>
        )
    } else if (variant === 'share') {
        return (
            <svg
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13.8964 2.49996C13.8964 3.62183 12.9871 4.53129 11.8652 4.53129C10.7433 4.53129 9.83398 3.62183 9.83398 2.49996C9.83398 1.37821 10.7433 0.46875 11.8652 0.46875C12.9871 0.46875 13.8964 1.37821 13.8964 2.49996Z"
                    fill="#2B4C6A"
                />
                <path
                    d="M11.8652 5.00004C10.4864 5.00004 9.36523 3.87875 9.36523 2.49996C9.36523 1.12129 10.4864 0 11.8652 0C13.244 0 14.3652 1.12129 14.3652 2.49996C14.3652 3.87875 13.244 5.00004 11.8652 5.00004ZM11.8652 0.9375C11.0033 0.9375 10.3027 1.63879 10.3027 2.49996C10.3027 3.36124 11.0033 4.06254 11.8652 4.06254C12.7271 4.06254 13.4277 3.36124 13.4277 2.49996C13.4277 1.63879 12.7271 0.9375 11.8652 0.9375Z"
                    fill="#2B4C6A"
                />
                <path
                    d="M13.8964 12.5C13.8964 13.6217 12.9871 14.5312 11.8652 14.5312C10.7433 14.5312 9.83398 13.6217 9.83398 12.5C9.83398 11.3781 10.7433 10.4686 11.8652 10.4686C12.9871 10.4686 13.8964 11.3781 13.8964 12.5Z"
                    fill="#2B4C6A"
                />
                <path
                    d="M11.8652 14.9999C10.4864 14.9999 9.36523 13.8786 9.36523 12.5C9.36523 11.1212 10.4864 9.99988 11.8652 9.99988C13.244 9.99988 14.3652 11.1212 14.3652 12.5C14.3652 13.8786 13.244 14.9999 11.8652 14.9999ZM11.8652 10.9374C11.0033 10.9374 10.3027 11.6387 10.3027 12.5C10.3027 13.3611 11.0033 14.0624 11.8652 14.0624C12.7271 14.0624 13.4277 13.3611 13.4277 12.5C13.4277 11.6387 12.7271 10.9374 11.8652 10.9374Z"
                    fill="#2B4C6A"
                />
                <path
                    d="M5.14652 7.50008C5.14652 8.62195 4.23706 9.5313 3.1152 9.5313C1.99345 9.5313 1.08398 8.62195 1.08398 7.50008C1.08398 6.37822 1.99345 5.46887 3.1152 5.46887C4.23706 5.46887 5.14652 6.37822 5.14652 7.50008Z"
                    fill="#2B4C6A"
                />
                <path
                    d="M3.1152 10C1.73653 10 0.615234 8.87887 0.615234 7.50008C0.615234 6.1213 1.73653 5.00012 3.1152 5.00012C4.49398 5.00012 5.61527 6.1213 5.61527 7.50008C5.61527 8.87887 4.49398 10 3.1152 10ZM3.1152 5.93762C2.25334 5.93762 1.55273 6.6388 1.55273 7.50008C1.55273 8.36137 2.25334 9.06255 3.1152 9.06255C3.97717 9.06255 4.67777 8.36137 4.67777 7.50008C4.67777 6.6388 3.97717 5.93762 3.1152 5.93762Z"
                    fill="#2B4C6A"
                />
                <path
                    d="M4.59144 7.20011C4.37389 7.20011 4.16263 7.08693 4.04762 6.88448C3.87699 6.5851 3.98205 6.20322 4.28142 6.0319L10.0807 2.7257C10.3801 2.55381 10.762 2.65887 10.9333 2.95939C11.1039 3.25877 10.9989 3.64065 10.6995 3.81197L4.90009 7.11817C4.80259 7.17379 4.69639 7.20011 4.59144 7.20011Z"
                    fill="#2B4C6A"
                />
                <path
                    d="M10.3895 12.3562C10.2844 12.3562 10.1782 12.3299 10.0807 12.2743L4.28134 8.9681C3.98196 8.79747 3.87702 8.41558 4.04765 8.11552C4.21759 7.81557 4.60005 7.70994 4.90012 7.88183L10.6995 11.188C10.9989 11.3587 11.1038 11.7406 10.9332 12.0406C10.8176 12.2431 10.6064 12.3562 10.3895 12.3562Z"
                    fill="#2B4C6A"
                />
            </svg>
        )
    } else if (variant === 'info') {
        return (
            <svg
                width={width || '12'}
                height={height || '12'}
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM6.13765 2C6.72065 2 7.20648 2.48583 7.17409 3.06883C7.17409 3.65182 6.68826 4.13765 6.10526 4.13765C5.52227 4.13765 5.03644 3.65182 5.03644 3.06883C5.06883 2.45344 5.55466 2 6.13765 2ZM4.43724 4.60729L4.43725 4.60729L4.43725 4.60729C4.47774 4.59919 4.51822 4.59109 4.55061 4.59109H6.5587C6.81781 4.59109 6.94737 4.72065 6.94737 4.94737C6.94737 5.1417 6.91498 5.36842 6.88259 5.56275C6.81781 5.93522 6.74494 6.31579 6.67206 6.69636C6.59919 7.07692 6.52632 7.45749 6.46154 7.82996C6.4436 7.97345 6.41573 8.11694 6.38893 8.25493C6.36734 8.36611 6.34644 8.47373 6.33199 8.5749V8.57491C6.33199 8.70446 6.33199 8.83401 6.36437 8.93117C6.39676 9.09312 6.52632 9.19028 6.68826 9.15789C6.77463 9.15789 6.861 9.1291 6.94737 9.10032C6.99055 9.08592 7.03374 9.07152 7.07692 9.06073C7.17409 9.02834 7.27126 8.96356 7.36842 8.89878C7.53036 8.83401 7.65992 8.93117 7.59514 9.09312C7.56275 9.19028 7.53036 9.28745 7.4332 9.35223C7.04453 9.74089 6.59109 9.96761 6.04049 10C5.78138 10 5.52227 10 5.26316 9.96761C4.84211 9.90283 4.2915 9.38461 4.38867 8.83401C4.41911 8.65132 4.44241 8.46863 4.46527 8.28931L4.46527 8.28927L4.46528 8.28923C4.49105 8.08708 4.51628 7.88919 4.55061 7.7004C4.6343 7.11454 4.74203 6.5527 4.85309 5.9735L4.8531 5.97341L4.90688 5.69231V5.56275C4.90688 5.27126 4.80972 5.17409 4.55061 5.1417C4.48583 5.12551 4.42915 5.11741 4.37247 5.10931C4.31579 5.10121 4.25911 5.09312 4.19433 5.07692C4.06478 5.01215 4 4.91498 4 4.81781C4.09717 4.72065 4.16194 4.65587 4.32389 4.62348C4.35627 4.62348 4.39676 4.61539 4.43724 4.60729Z"
                    fill="#666666"
                />
            </svg>
        )
    } else if (variant === 'arrowL') {
        return (
            <svg
                width="33"
                height="12"
                viewBox="0 0 33 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0.434315 5.43431C0.121895 5.74673 0.121895 6.25327 0.434315 6.56569L5.52548 11.6569C5.8379 11.9693 6.34443 11.9693 6.65685 11.6569C6.96927 11.3444 6.96927 10.8379 6.65685 10.5255L2.13137 6L6.65685 1.47452C6.96927 1.1621 6.96927 0.655565 6.65685 0.343146C6.34443 0.0307264 5.8379 0.0307264 5.52548 0.343146L0.434315 5.43431ZM33 5.2H1V6.8H33V5.2Z"
                    fill="#666666"
                />
            </svg>
        )
    } else if (variant === 'checkmark') {
        return (
            <svg
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M1.23048 3.71743L-0.000488281 4.92682L5.10712 9.99902L13.9995 1.19036L12.7502 -0.0009767L5.10712 7.58025L1.23048 3.71743Z"
                    fill="white"
                />
            </svg>
        )
    } else if (variant === 'account') {
        return (
            <svg
                {...props}
                width="18"
                height="20"
                viewBox="0 0 18 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.8303 5.77627C12.8303 7.8917 11.1154 9.6066 8.99999 9.6066C6.88456 9.6066 5.16967 7.8917 5.16967 5.77627C5.16967 3.66084 6.88456 1.94595 8.99999 1.94595C11.1154 1.94595 12.8303 3.66084 12.8303 5.77627ZM11.8522 10.3981C13.3994 9.44128 14.4303 7.72916 14.4303 5.77627C14.4303 2.77719 11.9991 0.345947 8.99999 0.345947C6.00091 0.345947 3.56967 2.77719 3.56967 5.77627C3.56967 7.72916 4.60054 9.44128 6.14781 10.3981C5.22072 10.6379 4.42012 10.9952 3.73185 11.4383C2.42374 12.2804 1.57682 13.3966 1.03036 14.485C0.485611 15.57 0.230503 16.6441 0.109936 17.439C0.0493336 17.8386 0.0218804 18.1734 0.00960912 18.4115C0.00346587 18.5307 0.00110557 18.6261 0.000327928 18.6937C-6.10485e-05 18.7276 -4.77898e-05 18.7553 8.11705e-05 18.7749L0.000313748 18.7969L0.000332016 18.7982L0.00046221 18.8057L0.000494866 18.8069L0.000528712 18.8089L0.00053439 18.81L0.000772526 18.8191C0.00102478 18.8264 0.00149611 18.8362 0.00237416 18.848C0.004125 18.8716 0.00752322 18.904 0.0141552 18.9423C0.0272529 19.0179 0.053851 19.1217 0.109151 19.2274C0.16497 19.334 0.251617 19.4453 0.384421 19.5281C0.518099 19.6115 0.686109 19.6581 0.89137 19.6539C1.09666 19.6497 1.26327 19.5964 1.3949 19.5092C1.5256 19.4225 1.611 19.3097 1.6662 19.2021C1.72096 19.0955 1.74743 18.9915 1.7605 18.9157C1.76712 18.8773 1.77051 18.8449 1.77226 18.8213C1.77313 18.8094 1.77361 18.7997 1.77386 18.7924L1.7741 18.7833L1.77413 18.7802L1.77417 18.7781L1.7741 18.7738L1.774 18.7633C1.77393 18.7529 1.77391 18.7357 1.77418 18.712C1.77473 18.664 1.77648 18.5898 1.78147 18.4931C1.79145 18.2995 1.8143 18.0175 1.86594 17.6771C1.96985 16.9919 2.18693 16.0925 2.63303 15.204C3.0774 14.3189 3.73998 13.4616 4.73101 12.8236C5.71628 12.1893 7.08177 11.7356 8.99999 11.7356C10.9182 11.7356 12.2837 12.1893 13.269 12.8236C14.26 13.4616 14.9226 14.3189 15.367 15.2039C15.8131 16.0925 16.0301 16.9919 16.134 17.6771C16.1857 18.0175 16.2085 18.2995 16.2185 18.4931C16.2235 18.5898 16.2253 18.664 16.2258 18.712C16.2259 18.724 16.226 18.7344 16.226 18.7431C16.226 18.7516 16.226 18.7585 16.226 18.7636L16.2259 18.7738L16.2258 18.7751L16.2258 18.779L16.2258 18.7802L16.2259 18.7833L16.2261 18.7924C16.2264 18.7997 16.2269 18.8094 16.2277 18.8213C16.2295 18.8449 16.2329 18.8773 16.2395 18.9157C16.2526 18.9915 16.279 19.0955 16.3338 19.2021C16.389 19.3097 16.4744 19.4225 16.6051 19.5092C16.7367 19.5964 16.9033 19.6497 17.1086 19.6539C17.3139 19.6581 17.482 19.6114 17.6157 19.5279C17.7485 19.445 17.8351 19.3336 17.8909 19.2268C17.9462 19.1211 17.9728 19.0172 17.9859 18.9415C17.9925 18.9032 17.9959 18.8708 17.9976 18.8471C17.9985 18.8353 17.999 18.8255 17.9992 18.8182L17.9995 18.8091L17.9995 18.8078L17.9995 18.805L17.9997 18.7983L17.9997 18.7969L17.9999 18.7741C18 18.7545 18 18.7276 17.9997 18.6937C17.9989 18.6261 17.9965 18.5307 17.9904 18.4115C17.9781 18.1734 17.9507 17.8386 17.89 17.439C17.7695 16.6441 17.5144 15.57 16.9696 14.485C16.4232 13.3966 15.5762 12.2804 14.2681 11.4383C13.5799 10.9952 12.7793 10.6379 11.8522 10.3981Z"
                    fill="#373B43"
                />
            </svg>
        )
    } else if (variant === 'image') {
        return (
            <svg
                width={width || '22'}
                height={height || '20'}
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19 12V15H22V17H19V20H17V17H14V15H17V12H19ZM19.008 0C19.556 0 20 0.445 20 0.993V10.342C19.3576 10.1151 18.6813 9.99944 18 10V2H2L2.001 16L11.293 6.707C11.465 6.53448 11.694 6.43073 11.9371 6.41526C12.1802 6.39979 12.4206 6.47367 12.613 6.623L12.706 6.708L16.252 10.258C15.4766 10.4943 14.7572 10.8851 14.1369 11.407C13.5167 11.9288 13.0086 12.5709 12.6432 13.2944C12.2779 14.0179 12.0628 14.808 12.0111 15.6169C11.9593 16.4258 12.0719 17.2368 12.342 18.001L0.992 18C0.728813 17.9997 0.476497 17.895 0.290489 17.7088C0.104482 17.5226 -1.33455e-07 17.2702 0 17.007V0.993C0.00183004 0.730378 0.1069 0.479017 0.292513 0.293218C0.478126 0.107418 0.72938 0.00209465 0.992 0H19.008ZM6 4C6.53043 4 7.03914 4.21071 7.41421 4.58579C7.78929 4.96086 8 5.46957 8 6C8 6.53043 7.78929 7.03914 7.41421 7.41421C7.03914 7.78929 6.53043 8 6 8C5.46957 8 4.96086 7.78929 4.58579 7.41421C4.21071 7.03914 4 6.53043 4 6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4Z"
                    fill="#666666"
                />
            </svg>
        )
    } else if (variant === 'trash') {
        return (
            <svg
                width={width || '10'}
                height={height || '12'}
                viewBox="0 0 10 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.10677 11.1196C1.10677 11.613 1.50678 11.9996 2.00012 11.9996H8.01353C8.50687 11.9996 8.90687 11.613 8.90687 11.1196L9.25354 3.86621H0.773438L1.10677 11.1196ZM6.60018 5.31956C6.60018 5.06623 6.74685 4.86622 7.00018 4.86622C7.25352 4.86622 7.40019 5.06623 7.40019 5.31956V10.333C7.40019 10.5863 7.25352 10.7863 7.00018 10.7863C6.74685 10.7863 6.60018 10.5863 6.60018 10.333V5.31956ZM4.60015 5.31956C4.60015 5.06623 4.74682 4.86622 5.00016 4.86622C5.25349 4.86622 5.40016 5.06623 5.40016 5.31956V10.333C5.40016 10.5863 5.25349 10.7863 5.00016 10.7863C4.74682 10.7863 4.60015 10.5863 4.60015 10.333V5.31956ZM2.60013 5.31956C2.60013 5.06623 2.7468 4.86622 3.00013 4.86622C3.25347 4.86622 3.40014 5.06623 3.40014 5.31956V10.333C3.40014 10.5863 3.25347 10.7863 3.00013 10.7863C2.7468 10.7863 2.60013 10.5863 2.60013 10.333V5.31956Z"
                    fill="#666666"
                />
                <path
                    d="M9.41267 1.60002H6.9993V0.413339C6.9993 0.173336 6.8793 0 6.62597 0H3.39926C3.14592 0 2.99925 0.173336 2.99925 0.413339V1.60002H0.612557C0.359221 1.60002 0.199219 1.78669 0.199219 2.04003V2.5467C0.199219 2.80003 0.359221 3.0667 0.612557 3.0667H9.426C9.67934 3.0667 9.81267 2.7867 9.81267 2.5467V2.04003C9.79934 1.78669 9.66601 1.60002 9.41267 1.60002ZM6.19929 1.60002H3.79926V0.80001H6.19929V1.60002Z"
                    fill="#666666"
                />
            </svg>
        )
    } else if (variant === 'settings') {
        return (
            <svg
                width={width || '12'}
                height={height || '12'}
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10.1552 6.54578C10.1762 6.37078 10.1902 6.18878 10.1902 5.99978C10.1902 5.81078 10.1762 5.62878 10.1482 5.45378L11.3312 4.52978C11.4362 4.44578 11.4642 4.29178 11.4012 4.17278L10.2812 2.23378C10.2112 2.10778 10.0642 2.06578 9.93822 2.10778L8.54522 2.66778C8.25121 2.44378 7.94322 2.26178 7.60022 2.12178L7.39021 0.63778C7.36922 0.49778 7.25022 0.39978 7.11022 0.39978H4.87021C4.73022 0.39978 4.61822 0.49778 4.59722 0.63778L4.38722 2.12178C4.04422 2.26178 3.72922 2.45078 3.44222 2.66778L2.04922 2.10778C1.92322 2.05878 1.77622 2.10778 1.70622 2.23378L0.586215 4.17278C0.516215 4.29878 0.544215 4.44578 0.656215 4.52978L1.83922 5.45378C1.81122 5.62878 1.79022 5.81778 1.79022 5.99978C1.79022 6.18178 1.80422 6.37078 1.83222 6.54578L0.649215 7.46978C0.544215 7.55378 0.516215 7.70778 0.579215 7.82678L1.69922 9.76578C1.76922 9.89178 1.91622 9.93378 2.04222 9.89178L3.43522 9.33178C3.72922 9.55578 4.03721 9.73778 4.38021 9.87778L4.59022 11.3618C4.61822 11.5018 4.73022 11.5998 4.87021 11.5998H7.11022C7.25022 11.5998 7.36922 11.5018 7.38321 11.3618L7.59321 9.87778C7.93621 9.73778 8.25121 9.54878 8.53822 9.33178L9.93122 9.89178C10.0572 9.94078 10.2042 9.89178 10.2742 9.76578L11.3942 7.82678C11.4642 7.70078 11.4362 7.55378 11.3242 7.46978L10.1552 6.54578ZM5.9902 8.09978C4.8352 8.09978 3.8902 7.15478 3.8902 5.99978C3.8902 4.84478 4.8352 3.89978 5.9902 3.89978C7.1452 3.89978 8.0902 4.84478 8.0902 5.99978C8.0902 7.15478 7.1452 8.09978 5.9902 8.09978Z"
                    fill="#666666"
                />
            </svg>
        )
    } else if (variant === 'dropdown') {
        return (
            <svg
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M4.99984 5.99977L0.756836 1.75677L2.17184 0.342773L4.99984 3.17177L7.82784 0.342773L9.24284 1.75677L4.99984 5.99977Z"
                    fill="#373b43"
                />
            </svg>
        )
    } else if (variant === 'edit') {
        return (
            <svg
                width={width || '12'}
                height={height || '12'}
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0.75 9.06279V11.2503H2.9375L9.38917 4.79862L7.20167 2.61112L0.75 9.06279ZM11.0809 3.1069C11.3084 2.8794 11.3084 2.5119 11.0809 2.2844L9.71588 0.919404C9.48838 0.691904 9.12088 0.691904 8.89338 0.919404L7.82588 1.9869L10.0134 4.1744L11.0809 3.1069Z"
                    fill="#666666"
                />
            </svg>
        )
    } else if (variant === 'save') {
        return (
            <svg
                width={width || '10'}
                height={height || '13'}
                viewBox="0 0 10 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0.916829 0.166626H9.0835C9.2382 0.166626 9.38658 0.228084 9.49597 0.33748C9.60537 0.446877 9.66683 0.59525 9.66683 0.749959V11.9167C9.66689 11.9689 9.65297 12.0201 9.62652 12.065C9.60006 12.11 9.56204 12.147 9.51641 12.1723C9.47078 12.1975 9.41922 12.2101 9.36708 12.2086C9.31495 12.2072 9.26416 12.1918 9.21999 12.164L5.00016 9.51746L0.780329 12.1635C0.736211 12.1912 0.685472 12.2066 0.633389 12.208C0.581306 12.2095 0.52978 12.197 0.484168 12.1718C0.438557 12.1466 0.400525 12.1097 0.374028 12.0648C0.34753 12.02 0.333535 11.9688 0.333496 11.9167V0.749959C0.333496 0.59525 0.394954 0.446877 0.504351 0.33748C0.613747 0.228084 0.76212 0.166626 0.916829 0.166626Z"
                    fill="#666666"
                />
            </svg>
        )
    } else if (variant === 'close') {
        return (
            <svg
                width={width || '14'}
                height={height || '14'}
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                    fill="#2B4C6A"
                />
            </svg>
        )
    } else if (variant === 'crumbArrow') {
        return (
            <svg
                width="5"
                height="9"
                viewBox="0 0 5 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M0.132984 8.20992C-0.0443286 8.04745 -0.0443286 7.78292 0.132984 7.62045L3.90202 4.16693L0.132985 0.711325C-0.0443283 0.548855 -0.0443283 0.284322 0.132985 0.121852C0.310298 -0.0406174 0.599 -0.0406174 0.776313 0.121852L4.86815 3.87115C4.95453 3.95447 5 4.0607 5 4.16693C5 4.27316 4.95453 4.37939 4.86588 4.46062L0.774039 8.20992C0.596726 8.37447 0.310297 8.37447 0.132984 8.20992Z"
                    fill="#999999"
                />
            </svg>
        )
    } else if (variant === 'facebook') {
        return (
            <svg
                width="10"
                height="18"
                viewBox="0 0 10 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M5.95067 17.0696V9.28393H8.65233L9.05766 6.24881H5.95067V4.31133C5.95067 3.43287 6.20192 2.83421 7.50621 2.83421L9.16701 2.83355V0.11883C8.8798 0.0827409 7.8939 0 6.74642 0C4.35029 0 2.70986 1.41419 2.70986 4.01074V6.24881H0V9.28393H2.70986V17.0696H5.95067Z"
                    fill="#2B4C6A"
                />
            </svg>
        )
    } else if (variant === 'reorder') {
        const [down, setDown] = useState(false)
        useEffect(() => {
            const handleDocumentMouseUp = () => {
                setDown(false)
            }
            const handleDocumentMouseDown = () => {
                setDown(true)
            }

            document.addEventListener('mouseup', handleDocumentMouseUp)
            document.addEventListener('mousedown', handleDocumentMouseDown)
            return () => {
                document.removeEventListener('mouseup', handleDocumentMouseUp)
                document.removeEventListener(
                    'mousedown',
                    handleDocumentMouseDown
                )
            }
        }, [])

        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="22"
                viewBox="0 0 10 17"
                fill="none"
                style={{ cursor: !down && 'grab' }}
                onPointerDown={(event) => {
                    dragControls.start(event)
                }}
            >
                <rect y="7" width="3" height="3" rx="1.5" fill="#666666" />
                <rect
                    x="7"
                    y="7"
                    width="3"
                    height="3"
                    rx="1.5"
                    fill="#666666"
                />
                <rect width="3" height="3" rx="1.5" fill="#666666" />
                <rect x="7" width="3" height="3" rx="1.5" fill="#666666" />
                <rect y="14" width="3" height="3" rx="1.5" fill="#666666" />
                <rect
                    x="7"
                    y="14"
                    width="3"
                    height="3"
                    rx="1.5"
                    fill="#666666"
                />
            </svg>
        )
    } else if (variant === 'instagram') {
        return (
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_3168_5578)">
                    <path
                        d="M17.982 5.29205C17.9398 4.33564 17.7852 3.67812 17.5636 3.10836C17.3351 2.50359 16.9834 1.96213 16.5227 1.51201C16.0726 1.05489 15.5276 0.699691 14.9298 0.474702C14.3568 0.253147 13.7027 0.0984842 12.7463 0.0563159C11.7827 0.0105764 11.4768 0 9.033 0C6.58917 0 6.28328 0.0105764 5.3233 0.0527447C4.36689 0.094913 3.70937 0.249713 3.13975 0.471131C2.53484 0.699691 1.99338 1.05132 1.54326 1.51201C1.08614 1.96213 0.731078 2.50716 0.505952 3.10493C0.284397 3.67812 0.129734 4.33207 0.0875659 5.28848C0.0418264 6.25203 0.03125 6.55792 0.03125 9.00176C0.03125 11.4456 0.0418264 11.7515 0.0839947 12.7115C0.126163 13.6679 0.280963 14.3254 0.502518 14.8952C0.731078 15.4999 1.08614 16.0414 1.54326 16.4915C1.99338 16.9486 2.53841 17.3038 3.13618 17.5288C3.70937 17.7504 4.36332 17.905 5.31986 17.9472C6.27971 17.9895 6.58573 17.9999 9.02957 17.9999C11.4734 17.9999 11.7793 17.9895 12.7393 17.9472C13.6957 17.905 14.3532 17.7504 14.9228 17.5288C16.1325 17.0611 17.0889 16.1047 17.5566 14.8952C17.778 14.322 17.9328 13.6679 17.975 12.7115C18.0172 11.7515 18.0278 11.4456 18.0278 9.00176C18.0278 6.55792 18.0242 6.25203 17.982 5.29205ZM16.3611 12.6411C16.3223 13.5202 16.1747 13.9949 16.0516 14.3114C15.7492 15.0956 15.1268 15.7179 14.3426 16.0204C14.0262 16.1434 13.548 16.2911 12.6724 16.3297C11.723 16.372 11.4382 16.3824 9.03658 16.3824C6.63491 16.3824 6.3466 16.372 5.40063 16.3297C4.52155 16.2911 4.04685 16.1434 3.73038 16.0204C3.34015 15.8761 2.98495 15.6476 2.69664 15.3487C2.39775 15.0568 2.16919 14.7052 2.02497 14.315C1.9019 13.9985 1.75424 13.5202 1.71565 12.6447C1.67334 11.6953 1.6629 11.4104 1.6629 9.00876C1.6629 6.6071 1.67334 6.31879 1.71565 5.37295C1.75424 4.49387 1.9019 4.01917 2.02497 3.7027C2.16919 3.31234 2.39775 2.95727 2.70021 2.66883C2.99196 2.36994 3.34359 2.14138 3.73395 1.99729C4.05042 1.87422 4.52869 1.72656 5.4042 1.68783C6.3536 1.64566 6.63848 1.63509 9.04001 1.63509C11.4452 1.63509 11.73 1.64566 12.676 1.68783C13.555 1.72656 14.0297 1.87422 14.3462 1.99729C14.7364 2.14138 15.0916 2.36994 15.3799 2.66883C15.6788 2.96071 15.9074 3.31234 16.0516 3.7027C16.1747 4.01917 16.3223 4.49731 16.3611 5.37295C16.4032 6.32236 16.4138 6.6071 16.4138 9.00876C16.4138 11.4104 16.4032 11.6917 16.3611 12.6411Z"
                        fill="#2B4C6A"
                    />
                    <path
                        d="M9.03313 4.37769C6.48037 4.37769 4.40918 6.44874 4.40918 9.00164C4.40918 11.5545 6.48037 13.6256 9.03313 13.6256C11.586 13.6256 13.6571 11.5545 13.6571 9.00164C13.6571 6.44874 11.586 4.37769 9.03313 4.37769ZM9.03313 12.0011C7.37703 12.0011 6.03369 10.6579 6.03369 9.00164C6.03369 7.3454 7.37703 6.00219 9.03313 6.00219C10.6894 6.00219 12.0326 7.3454 12.0326 9.00164C12.0326 10.6579 10.6894 12.0011 9.03313 12.0011Z"
                        fill="#2B4C6A"
                    />
                    <path
                        d="M14.9198 4.19496C14.9198 4.79109 14.4365 5.27444 13.8402 5.27444C13.2441 5.27444 12.7607 4.79109 12.7607 4.19496C12.7607 3.5987 13.2441 3.11548 13.8402 3.11548C14.4365 3.11548 14.9198 3.5987 14.9198 4.19496Z"
                        fill="#2B4C6A"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_3168_5578">
                        <rect width="18" height="18" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        )
    } else if (variant === 'cloud') {
        return (
            <svg
                width="56"
                height="36"
                viewBox="0 0 56 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M44.7456 15.5849L43.7557 15.7264C43.8271 16.2255 44.2589 16.5935 44.763 16.5847L44.7456 15.5849ZM12.699 10.7762L12.7643 11.774C13.1267 11.7503 13.4477 11.532 13.603 11.2037L12.699 10.7762ZM44.9167 35.9167C50.8078 35.9167 55.5834 31.1411 55.5834 25.25H53.5834C53.5834 30.0365 49.7032 33.9167 44.9167 33.9167V35.9167ZM55.5834 25.25C55.5834 19.359 50.8078 14.5834 44.9167 14.5834V16.5834C49.7032 16.5834 53.5834 20.4636 53.5834 25.25H55.5834ZM44.9167 14.5834C44.8537 14.5834 44.7908 14.5839 44.7283 14.585L44.763 16.5847C44.8143 16.5838 44.8655 16.5834 44.9167 16.5834V14.5834ZM45.7356 15.4434C44.4942 6.75899 37.0276 0.083374 28.0001 0.083374V2.08337C36.0182 2.08337 42.6531 8.0132 43.7557 15.7264L45.7356 15.4434ZM28.0001 0.083374C20.8405 0.083374 14.6637 4.28289 11.795 10.3486L13.603 11.2037C16.1536 5.81071 21.6425 2.08337 28.0001 2.08337V0.083374ZM12.6337 9.77831C5.81136 10.2249 0.416748 15.8987 0.416748 22.8334H2.41675C2.41675 16.9595 6.98665 12.1522 12.7643 11.774L12.6337 9.77831ZM0.416748 22.8334C0.416748 30.0591 6.27436 35.9167 13.5001 35.9167V33.9167C7.37892 33.9167 2.41675 28.9545 2.41675 22.8334H0.416748ZM44.9167 33.9167H13.5001V35.9167H44.9167V33.9167Z"
                    fill="#666666"
                />
                <path
                    d="M28 27.6666L28 13.1666"
                    stroke="#666666"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.75 18L28 13.1666L35.25 18"
                    stroke="#666666"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    } else if (variant === 'dragDots') {
        return (
            <svg
                width="10"
                height="17"
                viewBox="0 0 10 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect y="7" width="3" height="3" rx="1.5" fill="white" />
                <rect x="7" y="7" width="3" height="3" rx="1.5" fill="white" />
                <rect width="3" height="3" rx="1.5" fill="white" />
                <rect x="7" width="3" height="3" rx="1.5" fill="white" />
                <rect y="14" width="3" height="3" rx="1.5" fill="white" />
                <rect x="7" y="14" width="3" height="3" rx="1.5" fill="white" />
            </svg>
        )
    } else if (variant === 'x') {
        return (
            <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12.1929 12.4148C12.3064 12.3013 12.3963 12.1667 12.4577 12.0185C12.5191 11.8703 12.5507 11.7114 12.5507 11.551C12.5507 11.3906 12.5191 11.2318 12.4577 11.0836C12.3963 10.9354 12.3064 10.8007 12.1929 10.6873L2.69192 1.18627C2.46284 0.957195 2.15215 0.828501 1.82819 0.828501C1.50423 0.828501 1.19353 0.957195 0.964458 1.18627C0.735382 1.41535 0.606689 1.72604 0.606689 2.05C0.606689 2.37396 0.735382 2.68465 0.964458 2.91373L10.4655 12.4148C10.6946 12.6438 11.0052 12.7725 11.3292 12.7725C11.6532 12.7725 11.9639 12.6438 12.1929 12.4148Z"
                    fill="#666666"
                />
                <path
                    d="M12.3034 1.0753C12.19 0.961872 12.0554 0.871896 11.9072 0.81051C11.759 0.749124 11.6001 0.717529 11.4397 0.717529C11.2793 0.717529 11.1205 0.749124 10.9723 0.81051C10.8241 0.871896 10.6894 0.961872 10.576 1.0753L1.07496 10.5763C0.845888 10.8054 0.717194 11.1161 0.717194 11.44C0.717194 11.764 0.845888 12.0747 1.07496 12.3038C1.30404 12.5329 1.61473 12.6615 1.93869 12.6615C2.26265 12.6615 2.57335 12.5329 2.80242 12.3038L12.3034 2.80276C12.5325 2.57368 12.6612 2.26299 12.6612 1.93903C12.6612 1.61507 12.5325 1.30437 12.3034 1.0753Z"
                    fill="#666666"
                />
            </svg>
        )
    } else if (variant === 'star') {
        return (
            <svg
                width={width || '12'}
                height={height || '12'}
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.1445 4.44696L7.84688 3.96771L6.37277 0.979233C6.33251 0.897411 6.26627 0.831173 6.18445 0.790911C5.97925 0.689607 5.72988 0.774027 5.62728 0.979233L4.15317 3.96771L0.855584 4.44696C0.76467 4.45995 0.681548 4.50281 0.617908 4.56775C0.540971 4.64682 0.498575 4.75321 0.500037 4.86353C0.501498 4.97385 0.546696 5.07908 0.625701 5.15609L3.01155 7.48219L2.44788 10.7668C2.43466 10.8432 2.44312 10.9218 2.47229 10.9936C2.50146 11.0655 2.55017 11.1277 2.61291 11.1733C2.67565 11.2188 2.74991 11.2459 2.82725 11.2514C2.9046 11.257 2.98194 11.2407 3.05051 11.2045L6.00003 9.65374L8.94954 11.2045C9.03007 11.2473 9.12358 11.2616 9.21319 11.246C9.43918 11.2071 9.59114 10.9928 9.55217 10.7668L8.9885 7.48219L11.3744 5.15609C11.4393 5.09245 11.4821 5.00933 11.4951 4.91841C11.5302 4.69113 11.3718 4.48073 11.1445 4.44696V4.44696Z"
                    fill="#666666"
                />
            </svg>
        )
    } else if (variant === 'youtube') {
        return (
            <svg
                width="18"
                height="14"
                viewBox="0 0 18 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M16.9518 2.41492C17.3327 3.89992 17.3327 6.99992 17.3327 6.99992C17.3327 6.99992 17.3327 10.0999 16.9518 11.5849C16.7402 12.4057 16.121 13.0516 15.3368 13.2699C13.9127 13.6666 8.99935 13.6666 8.99935 13.6666C8.99935 13.6666 4.08852 13.6666 2.66185 13.2699C1.87435 13.0482 1.25602 12.4032 1.04685 11.5849C0.666016 10.0999 0.666016 6.99992 0.666016 6.99992C0.666016 6.99992 0.666016 3.89992 1.04685 2.41492C1.25852 1.59409 1.87768 0.948252 2.66185 0.729918C4.08852 0.333252 8.99935 0.333252 8.99935 0.333252C8.99935 0.333252 13.9127 0.333252 15.3368 0.729918C16.1243 0.951585 16.7427 1.59659 16.9518 2.41492ZM7.33268 9.91658L12.3327 6.99992L7.33268 4.08325V9.91658Z"
                    fill="#FF0000"
                />
            </svg>
        )
    } else if (variant === 'spotify') {
        return (
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M8.99916 0.428467C4.28488 0.428467 0.427734 4.28561 0.427734 8.9999C0.427734 13.7142 4.28488 17.5713 8.99916 17.5713C13.7134 17.5713 17.5706 13.7142 17.5706 8.9999C17.5706 4.28561 13.7563 0.428467 8.99916 0.428467ZM12.2134 12.9856C10.1992 11.7428 7.67059 11.4856 4.67059 12.1713C4.37059 12.257 4.11345 12.0428 4.02773 11.7856C3.94202 11.4856 4.15631 11.2285 4.41345 11.1428C7.67059 10.4142 10.4992 10.7142 12.7277 12.0856C13.0277 12.2142 13.0706 12.557 12.942 12.8142C12.7706 13.0713 12.4706 13.157 12.2134 12.9856ZM13.0706 10.6713C10.7563 9.25704 7.24202 8.82847 4.54202 9.68561C4.19916 9.77132 3.81345 9.59989 3.72773 9.25704C3.64202 8.91418 3.81345 8.52847 4.15631 8.44275C7.28488 7.4999 11.142 7.97132 13.7992 9.59989C14.0563 9.72847 14.1849 10.157 13.9706 10.457C13.7563 10.757 13.3706 10.8856 13.0706 10.6713ZM4.11345 7.07132C3.68488 7.19989 3.25631 6.94275 3.12773 6.55704C2.99916 6.12847 3.25631 5.69989 3.64202 5.57132C6.68488 4.67132 11.6992 4.84275 14.8706 6.72847C15.2563 6.94275 15.3849 7.45704 15.1706 7.84275C14.9563 8.14275 14.442 8.27132 14.0563 8.05704C11.3134 6.42847 6.72773 6.25704 4.11345 7.07132Z"
                    fill="#1DB954"
                />
            </svg>
        )
    } else if (variant === 'google') {
        return (
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9 1.27979V2.43517V1.27979ZM9 15.5645V16.7199V15.5645ZM9 5.79628V12.2034V5.79628Z"
                    fill="black"
                />
                <path
                    d="M9 5.79628V12.2034M9 1.27979V2.43517V1.27979ZM9 15.5645V16.7199V15.5645Z"
                    stroke="#FAB908"
                    strokeWidth="2.25825"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.0625 4.79883V8.73763V4.79883ZM5.0625 12.0987V13.2016V12.0987Z"
                    fill="black"
                    stroke="#EA4335"
                    strokeWidth="2.25825"
                />
                <path
                    d="M12.9375 9.2628V13.2016V9.2628ZM12.9375 5.90169V4.79883V5.90169Z"
                    fill="black"
                    stroke="#34A853"
                    strokeWidth="2.25825"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M16.8262 8.42236V9.57775V8.42236Z" fill="black" />
                <path
                    d="M16.8262 8.42236V9.57775"
                    stroke="#4285F4"
                    strokeWidth="2.25825"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M1.17383 8.42236V9.57775V8.42236Z" fill="black" />
                <path
                    d="M1.17383 8.42236V9.57775"
                    stroke="#0066D9"
                    strokeWidth="2.25825"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    } else if (variant === 'rectangle') {
        return (
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    x="10.3135"
                    y="-1"
                    width="16"
                    height="16"
                    rx="4"
                    transform="rotate(45 10.3135 -1)"
                    fill="white"
                />
            </svg>
        )
    } else if (variant === 'youtube2') {
        return (
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M17.2984 3.75357C16.6487 2.9812 15.4491 2.66614 13.1581 2.66614H4.84177C2.49834 2.66614 1.27841 3.00152 0.631103 3.82383C0 4.62558 0 5.80691 0 7.44189V10.5582C0 13.7256 0.7488 15.3338 4.84177 15.3338H13.1581C15.1449 15.3338 16.2458 15.0558 16.958 14.3742C17.6884 13.6752 18 12.534 18 10.5582V7.44189C18 5.71766 17.9512 4.52937 17.2984 3.75357ZM11.5561 9.43025L7.77966 11.4039C7.69523 11.448 7.60291 11.4699 7.5107 11.4699C7.4063 11.4699 7.30214 11.4418 7.20987 11.386C7.03614 11.2807 6.93006 11.0924 6.93006 10.8893V6.95461C6.93006 6.75185 7.03585 6.56372 7.20923 6.45839C7.38267 6.35306 7.59838 6.34586 7.77832 6.43934L11.5547 8.4003C11.7469 8.50005 11.8675 8.6984 11.8678 8.91481C11.868 9.13139 11.7479 9.33003 11.5561 9.43025Z"
                    fill="#2B4C6A"
                />
            </svg>
        )
    } else if (variant === 'bookmark') {
        if (fill) {
            return (
                <svg
                    width="10"
                    height="13"
                    viewBox="0 0 10 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0.916341 0.166992H9.08301C9.23772 0.166992 9.38609 0.22845 9.49549 0.337847C9.60488 0.447243 9.66634 0.595616 9.66634 0.750326V11.9171C9.66641 11.9692 9.65249 12.0204 9.62603 12.0654C9.59958 12.1103 9.56155 12.1474 9.51592 12.1726C9.47029 12.1979 9.41873 12.2104 9.36659 12.209C9.31446 12.2076 9.26367 12.1922 9.21951 12.1644L4.99967 9.51783L0.779841 12.1638C0.735722 12.1915 0.684984 12.2069 0.632901 12.2084C0.580817 12.2099 0.529291 12.1974 0.48368 12.1722C0.438068 12.147 0.400037 12.11 0.373539 12.0652C0.347042 12.0203 0.333047 11.9692 0.333008 11.9171V0.750326C0.333008 0.595616 0.394466 0.447243 0.503862 0.337847C0.613258 0.22845 0.761631 0.166992 0.916341 0.166992Z"
                        fill="#666666"
                    />
                </svg>
            )
        } else {
            return (
                <svg
                    width="10"
                    height="13"
                    viewBox="0 0 10 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0.916341 0.166992H9.08301C9.23772 0.166992 9.38609 0.22845 9.49549 0.337847C9.60488 0.447243 9.66634 0.595616 9.66634 0.750326V11.9171C9.66641 11.9692 9.65249 12.0204 9.62603 12.0654C9.59958 12.1103 9.56155 12.1474 9.51592 12.1726C9.47029 12.1979 9.41873 12.2104 9.36659 12.209C9.31446 12.2076 9.26367 12.1922 9.21951 12.1644L4.99967 9.51783L0.779841 12.1638C0.735722 12.1915 0.684984 12.2069 0.632901 12.2084C0.580817 12.2099 0.529291 12.1974 0.48368 12.1722C0.438068 12.147 0.400037 12.11 0.373539 12.0652C0.347042 12.0203 0.333047 11.9692 0.333008 11.9171V0.750326C0.333008 0.595616 0.394466 0.447243 0.503862 0.337847C0.613258 0.22845 0.761631 0.166992 0.916341 0.166992ZM8.49967 1.33366H1.49967V10.3357L4.99967 8.14174L8.49967 10.3357V1.33366Z"
                        fill="#666666"
                    />
                </svg>
            )
        }
    } else if (variant === 'heart') {
        if (fill) {
            return (
                <svg
                    width={width || '14'}
                    height={height || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.99984 12.4542L6.154 11.6842C3.14984 8.96 1.1665 7.16333 1.1665 4.95833C1.1665 3.16167 2.57817 1.75 4.37484 1.75C5.38984 1.75 6.364 2.2225 6.99984 2.96917C7.63567 2.2225 8.60984 1.75 9.62484 1.75C11.4215 1.75 12.8332 3.16167 12.8332 4.95833C12.8332 7.16333 10.8498 8.96 7.84567 11.69L6.99984 12.4542Z"
                        fill="#2B4C6A"
                    />
                </svg>
            )
        } else {
            return (
                <svg
                    width={width || '14'}
                    height={height || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9.62484 1.75C8.60984 1.75 7.63567 2.2225 6.99984 2.96917C6.364 2.2225 5.38984 1.75 4.37484 1.75C2.57817 1.75 1.1665 3.16167 1.1665 4.95833C1.1665 7.16333 3.14984 8.96 6.154 11.69L6.99984 12.4542L7.84567 11.6842C10.8498 8.96 12.8332 7.16333 12.8332 4.95833C12.8332 3.16167 11.4215 1.75 9.62484 1.75ZM7.05817 10.8208L6.99984 10.8792L6.9415 10.8208C4.16484 8.30667 2.33317 6.64417 2.33317 4.95833C2.33317 3.79167 3.20817 2.91667 4.37484 2.91667C5.27317 2.91667 6.14817 3.49417 6.45734 4.29333H7.54817C7.8515 3.49417 8.7265 2.91667 9.62484 2.91667C10.7915 2.91667 11.6665 3.79167 11.6665 4.95833C11.6665 6.64417 9.83484 8.30667 7.05817 10.8208Z"
                        fill="#2B4C6A"
                    />
                </svg>
            )
        }
    }
}
